export default __webpack_public_path__ + "static/media/0.3b6a8c0a.png";